<template>
  <div class="select-search">
    <label for=""
      >{{ label }} <span v-if="required" class="text-danger">*</span></label
    >
    <v-select
      class="select-search-input"
      :label="name"
      v-model="selected"
      :options="options"
      :loading="loading"
      :disabled="disabled"
      :placeholder="placeholder"
      @input="handleInput"
      @search="handleSearch"
    >
      <template slot="no-options">
        <slot name="no-options">Sin opciones</slot>
      </template>
    </v-select>
  </div>
</template>

<script>
import { debounce } from "@/services/health-tracker/diagnostic/service";
export default {
  props: {
    label: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    options: {
      type: Array,
      default: () => [],
    },
    required: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      selected: null,
    };
  },
  watch: {
    value() {
      const me = this;
      me.selected = me.value;
    },
  },
  methods: {
    handleInput(option) {
      const me = this;
      me.$emit("input", option);
    },
    handleSearch: debounce(function(search) {
      search !== null && search !== "" && this.$emit("search", search);
    }, 300)
  },
  mounted() {
    const me = this;
    me.selected = me.value;
  },
};
</script>

<style lang="scss">
.select-search {
  label {
    font-family: "Muli", sans-serif;
    font-size: 16px;
    line-height: 20px;
    color: #263238;
  }
  .select-search-input .vs__dropdown-toggle {
    min-height: 44px !important;
    border-radius: 8px !important;
    border: 1px solid #cfd8dc !important;
    color: #263238 !important;
    .vs__actions {
      .vs__clear {
        display: none !important;
      }
    }
    .vs__selected-options {
      .vs__search {
        font-size: 16px !important;
      }
    }
  }
}
</style>
